import Vue from "vue"
import axios from "axios"
import qs from "qs"

/**
 * Servicio para conectarse con la API de carreras
 *
 * La ruta de la api viende de env
 **/

let BASE_URL = process.env.VUE_APP_API_URL

const createService = (plural, singular) => ({
    get _instance() {
        let _instance = axios.create({
            baseURL: `${BASE_URL}/${plural}/`
        })

        _instance.interceptors.request.use(config => {
            config.paramsSerializer = params => {
                return qs.stringify(params, {
                    arrayFormat: "brackets",
                    encode: false
                })
            }

            return config
        })

        _instance.interceptors.response.use(
            x => x,
            error => {
                if (error.response.status == 401) {
                    location.href = "/login"
                    localStorage.removeItem("jwt")
                    localStorage.removeItem("usuario")

                    return Promise.reject({ message: "Redirecting" })
                }

                return Promise.reject(error)
            }
        )

        return _instance
    },

    setToken() {
        const token = localStorage.getItem("jwt")
        if (token) {
            Vue.prototype.$http.defaults.headers.common["Authorization"] = token
        } else {
            Vue.prototype.$http.defaults.headers.common["Authorization"] = ""
        }
    },

    create(params) {
        this.setToken()

        return this._instance
            .post(``, { [singular]: params })
            .then(response => new Promise(resolve => resolve(response.data)))
    },
    find(id, params) {
        this.setToken()

        return this._instance.get(`${id}`, { params }).then(response => new Promise(resolve => resolve(response.data)))
    },

    where(params = {}) {
        this.setToken()

        return this._instance.get(``, { params }).then(response => new Promise(resolve => resolve(response.data)))
    },

    update(item = {}) {
        this.setToken()

        return this._instance
            .patch(`${item.id}`, { [singular]: item })
            .then(response => new Promise(resolve => resolve(response.data)))
    },

    destroy(id) {
        this.setToken()

        return this._instance.delete(`${id}`).then(response => new Promise(resolve => resolve(response.data)))
    }
})

const AreasService = createService("areas", "area")
const AudiovisualesService = createService("audiovisuales", "audiovisual")
const CarreraSedesService = createService("carrera_sedes", "carreraSede")
const CarrerasService = createService("carreras", "carrera")
const InfoAdicionalesService = createService("info_adicionales", "infoAdicional")
const PonderablesService = createService("ponderables", "ponderable")
const PonderacionesService = createService("ponderaciones", "ponderacion")
const SedeImagenesService = createService("sede_imagenes", "sedeImagen")
const SedesService = createService("sedes", "sede")
const SolicitudInformacionesService = createService("solicitud_informaciones", "solicitudInformacion")
const TipoAudiovisualesService = createService("tipo_audiovisuales", "tipoAudiovisual")
const UniversidadesService = createService("universidades", "universidad")
const UploadsService = createService("uploads", "upload")
const UniversidadRecomendadaService = createService("universidad_recomendadas", "universidadrecomendada")
const PlataformaService = createService("plataformas", "plataforma")
const CampoExtraService = createService("campo_extras", "campoExtra")
const LugaresService = createService("lugares", "lugar")
const PaisesService = createService("paises", "pais")
const PonderableGeneradoresService = createService("ponderable_generadores", "ponderableGenerador")

export {
    AreasService,
    AudiovisualesService,
    CarreraSedesService,
    CarrerasService,
    InfoAdicionalesService,
    PonderablesService,
    PonderableGeneradoresService,
    PonderacionesService,
    SedeImagenesService,
    SedesService,
    SolicitudInformacionesService,
    TipoAudiovisualesService,
    UniversidadesService,
    UploadsService,
    UniversidadRecomendadaService,
    PlataformaService,
    CampoExtraService,
    LugaresService,
    PaisesService
}
